import { LoadingOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { ReactComponent as DownloadIcon } from 'app/assets/img/download.svg';
import { StyledStack } from 'app/components/Stack';
import StyledButton from 'app/components/StyledButton';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import { CommonText } from 'app/pages/NewAccount/CheckTickets/styled';
import { StyledCheckbox } from 'app/pages/NewAccount/CheckTickets/UpgradeSummary/_TicketExportForm';
import { downloadSelectedPdfApi } from 'app/services/checkDeliverPrintTicketApi';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CustomModalContainer from './_ModalContainer';

enum ExportType {
  ZIP = '1',
  PDF = '0',
}

const ApplicationType = ['pdf', 'zip'];

const DownLoadModal = ({
  selectedParams,
  submitNumber,
  maxFile,
  otp = '',
  guest = '',
}) => {
  const [open, setOpen] = useState(false);
  const translations = useSelector(selectTranslations);
  const [exportType, setExportType] = useState(ExportType.ZIP);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const onCloseDialog = () => {
    setOpen(false);
  };

  const listExportOptions = [
    {
      id: ExportType.ZIP,
      name: translations?.['b2c.pdf.export-zip'],
    },
    {
      id: ExportType.PDF,
      name: translations?.['b2c.pdf.export-pdf'],
    },
  ];

  const handleOpenModal = () => {
    const selectNumber = selectedParams?.tickets?.length;
    if (selectNumber === 0) {
      setErrorMsg(translations?.['b2c.pdf.please-choose-ticket']);
    } else if (selectNumber > maxFile) {
      setErrorMsg(translations?.['b2c.pdf.max-download-file'] + ' ' + maxFile);
    } else {
      setOpen(true);
    }
  };

  const handleChangeExportType = e => {
    const value = e.target.value;
    setExportType(value);
  };

  const handleDownload = async () => {
    const ticketIds = selectedParams?.tickets?.map(item => item.orderItemId);
    const body = {
      ticketIds,
      isZip: exportType === '1' ? true : false,
    };
    const params = {
      id: selectedParams.orderId,
      lang: selectedParams.lang,
      otp: otp || undefined,
    };
    try {
      setOpen(false);
      setIsLoading(true);
      const res = await downloadSelectedPdfApi(params, body);
      const blob = new Blob([res.data], {
        type: `application/${ApplicationType[exportType]}`,
      });
      const url = URL.createObjectURL(blob);
      const element = document.createElement('a');
      element.style.display = 'none';
      element.href = url;
      element.download = submitNumber + '_' + moment().format('DDMMyyyyhhmmss');
      document.body.appendChild(element);
      element.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Tooltip
        color="white"
        title={translations?.['b2c.pdf.download-selected-ticket']}
        overlayInnerStyle={{
          color: 'black',
        }}
      >
        <div style={{ textAlign: 'left', width: 20 }}>
          {isLoading ? (
            <LoadingOutlined style={{ fontSize: 16, color: '#F8B117' }} spin />
          ) : (
            <DownloadIcon
              style={{ cursor: 'pointer' }}
              onClick={handleOpenModal}
            />
          )}
        </div>
      </Tooltip>
      {!!errorMsg && (
        <CustomModalContainer
          open={!!errorMsg}
          onCloseDialog={() => setErrorMsg('')}
        >
          {errorMsg}
        </CustomModalContainer>
      )}
      {open && (
        <CustomModalContainer open={open} onCloseDialog={onCloseDialog}>
          <StyledStack direction={'column'} rowGap={'12px'}>
            <CommonText>
              {translations?.['b2c.pdf.choose-export-type-title']}
            </CommonText>
            <StyledStack direction={'column'} rowGap={'8px'}>
              {listExportOptions.map((i, index) => {
                const value = i?.id;
                return (
                  <StyledCheckbox
                    style={{ borderRadius: '50%', marginLeft: 0 }}
                    key={index}
                    checked={value === exportType}
                    value={value}
                    onChange={handleChangeExportType}
                  >
                    {i?.name}
                  </StyledCheckbox>
                );
              })}
            </StyledStack>
            <StyledButton
              onClick={handleDownload}
              style={{
                marginTop: 12,
                alignSelf: 'center',
                color: 'white',
                backgroundImage: 'linear-gradient(to right, #f06f24, #F8B117)',
              }}
            >
              {translations?.['b2c.btn.confirm']}
            </StyledButton>
          </StyledStack>
        </CustomModalContainer>
      )}
    </>
  );
};

export default DownLoadModal;
